<template>
    <!-- 樣式：確認頁面，變更前與變更後外框 -->
    <div>
        <h4
            v-if="title!==''"
            class="mb-1.5 md:mb-2.5"
        >
            {{ title }}
        </h4>
        <ul class="border-green-gray mb-4 md:mb-5">
            <li class="flex items-start bg-gray-50 pb-1.5">
                <div class="mr-2.5 md:mr-6 pt-0.5 md:pt-0 text-sm flex-shrink-0 md:leading-7">
                    變更前
                </div>
                <div class="flex-grow">
                    <slot name="before" />
                </div>
            </li>
            <li class="flex items-start pb-1.5">
                <div class="mr-2.5 md:mr-6 pt-0.5 md:pt-0 text-sm flex-shrink-0 md:leading-7">
                    變更後
                </div>
                <div class="flex-grow">
                    <slot name="after" />
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
    },
};
</script>
<style lang="scss" scoped>
:deep(.border-green-gray) {
    li {
        @apply p-2.5 md:px-4 text-base xs:text-lg;
    }
    li:not(:first-child) {
        @apply border-t border-dashed border-gray-200 mb-[-0.125rem];
    }
}
</style>
